import React from "react";
import { Box } from "@mui/material";

const ScribeHeader: React.FC = () => (
  <Box
    sx={{
      position: "relative",
      height: 2,
      mt: { xs: 1.25, sm: 1.5 },
      mb: { xs: 2.5, sm: 2.5 },
      "&::before": {
        content: '""',
        position: "absolute",
        top: 0,
        left: "50%",
        transform: "translateX(-50%)",
        width: 480,
        maxWidth: "100%",
        height: 2,
        background:
          "linear-gradient(90deg, transparent 0%, var(--teal) 25%, var(--cyan) 50%, var(--teal) 75%, transparent 100%)",
        animation: "headerShimmer 4s ease-in-out infinite",
      },
    }}
  />
);

export default ScribeHeader;
